// extracted by mini-css-extract-plugin
export default {"cell":"PageSummary_cell__iExBR","text-main":"PageSummary_text-main__XLjnX"};